import type { RouteRecordName } from 'vue-router'
import type { useAuthStore } from '@/features/auth/stores/auth.store'

type AuthLike = Pick<ReturnType<typeof useAuthStore>, 'can'>

export function isRecruitmentCenterRouteName(name: RouteRecordName | null | undefined): boolean {
  const routeName = String(name ?? '')
  if (routeName === 'recruiter-workbench') return true
  if (routeName.startsWith('recruitment-')) return true
  if (routeName === 'lead-library-personal' || routeName === 'inbox') return true
  return false
}

export function isRecruitmentCenterRoute(route: {
  name?: RouteRecordName | null
  meta?: { moduleNav?: string }
}): boolean {
  if (route.meta?.moduleNav === 'recruitment') return true
  return isRecruitmentCenterRouteName(route.name)
}

export function canAccessRecruitmentCenter(auth: AuthLike): boolean {
  return auth.can('recruitment_center.view')
}
